<template>
    <p v-if="showAs == 'list-view' && (item.qtyPreceding !== null || item.qtyLast !== null || parseInt(item.qtyPreceding) > 0 || parseInt(item.qtyLast) > 0)" class="info-bestb">
        {{ $t("Vorige periode") }}: <b>{{ item.qtyPreceding }}</b><br>
        {{ $t("Huidige periode") }}: <b>{{ item.qtyLast }}</b><br>
        {{ $t("Laatst besteld") }}: <b>
        <template v-if="item.lastOrderDate">
            {{ item.lastOrderDate.toLocaleDateString("nl-BE") }} -
        </template>
        <template v-if="item.lastSellingPrice">
            {{ formatCurrency(item.lastSellingPrice) }}
        </template></b>
    </p>
    <div v-else-if="showAs == 'grid-view' && (item.qtyPreceding !== null || item.qtyLast !== null)" class="info-bestb">
        <span class="tag">{{ $t("Vorige periode") }}: <b>{{ item.qtyPreceding }}</b></span>
        <span class="tag">{{ $t("Huidige periode") }}: <b>{{ item.qtyLast }}</b></span>
        <span class="tag">{{ $t("Laatst besteld") }}: <b>
            <template v-if="item.lastOrderDate">
                {{ item.lastOrderDate.toLocaleDateString("nl-BE") }} -
            </template>
            <template v-if="item.lastSellingPrice">
                {{ formatCurrency(item.lastSellingPrice) }}
            </template></b>
        </span>
    </div>
</template>

<script>
import { helpers } from "@/js/mixins/helpers.js";

export default {
    name: "BestBInfo",

    mixins: [helpers],

    props: {
        item: {
            type: Object,
            default: () => {
                return {}
            }
        },
        showAs: {
            type: String,
            default: 'thumbnail'
        }
    }
}
</script>